import axios from './axios.js';

const request = {
    login: {
        post: ({ body }) => axios.post(`/login/signin`, body),
        signout: ({ }) => axios.get(`/login/signout`),
        setWorkingRole: ({ role }) => {
            const params = { role };
            return axios.get(`/login/setWorkingRole`, { params });
        },
        requestResetPassword: ({ params }) => axios.get(`/puiuser/requestResetPassword`, { params }),
        registry: ({ body }) => axios.post(`/uservisitor/insert`, body)
    },
    externalSale: {

        getSaleData: ({ campaignHash, params }) => {
            axios.get(`/externalsale/addclick?hash=${campaignHash}`, { params });
            return axios.get(`/externalsale/campaign/${campaignHash}`, { params });
        },
        getCampaignUserData: ({ campaignHash, userHash, params }) => {
            axios.get(`/externalsale/addclickuser/campaign/${campaignHash}/user/${userHash}`, { params });
            return axios.get(`/externalsale/campaign/user/${userHash}`, { params });
        },
        getCampaignDetailByUser: ({ campaignHash, userHash, params }) => {
            return axios.get(`/externalsale/campaignDetail/campaign/${campaignHash}/user/${userHash}`, { params });
        },
        getCampaignInvData: ({ invHash, params }) => {
            axios.get(`/externalsale/addclickInvitator?hash=${invHash}`, { params });
            return axios.get(`/externalsale/campaign/inv/${invHash}`, { params });
        },
        performSale: ({ body }) => {
            return axios.post(`/externalsale/performSale`, body);
        },
        downloadTickets: ({ id }) => {
            return axios.get(`/externalsale/tickets/${id}`, {
                headers: {
                    Accept: 'application/octet-stream'
                },
                responseType: 'blob'
            });
        },
        changeOrderStatus: ({ params }) => {
            return axios.get(`/externalsale/changeOrderStatus`, { params });
        },
        checkOrderStatus: ({ params }) => axios.get(`/externalsale/checkOrderStatus`, { params }),
        checktoken: (jwt) => {
            axios.defaults.headers.common['Authorization'] = jwt;
            return axios.get(`/externalsale/checktoken`);
        }
    },
    event: {
        getEventData: ({ params }) => axios.get(`/event/get`, { params }),
        getEventDiscountCards: ({ params }) => axios.get(`/event/getEventDiscountCards`, { params }),
        donwloadDocumentDiscountCard: ({ params }) =>
            axios.get(`/event/donwloadDocumentDiscountCard`, {
                params,
                headers: {
                    Accept: 'application/octet-stream'
                },
                responseType: 'blob'
            }),
        getEventImg: ({ evenid }) => {
            const params = {
                model: 'event',
                pk: evenid,
                role: 'event_app_primary'
            };
            return axios.get(`puidocument/getDocuments`, { params });
        }
    },
    ticketbatch: {
        calculateTicketsPrice: ({ params }) => axios.get(`/ticketbatch/calculateTicketsPrice`, { params })
    },
    country: {
        getAll: ({ params }) => axios.get(`/country/getAll`, { params })
    },
    province: {
        getAll: ({ params }) => axios.get(`/province/getAll`, { params })
    }
};

export default request;
